import browserLang from 'Helpers/detect-language'
import LANGUAGES from 'Constants/lang'

const userLang = LANGUAGES[browserLang] ? browserLang : 'en'
const USER_LANG = localStorage.getItem('lang') || userLang

export default USER_LANG
